import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { IPlayer } from '../../models/player';
import { Observable } from 'rxjs';
import { MatTableDataSource, MatSort, MatPaginator } from '@angular/material';
import { TimeService } from '../../services/time/time.service';
import { OwnerService } from '../../services/owner.service';

@Component({
  selector: 'app-player-list',
  templateUrl: './player-list.component.html',
  styleUrls: ['./player-list.component.css']
})
export class PlayerListComponent implements OnInit {
  players = new MatTableDataSource([]);
  allPlayers = [];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns: string[] = [];
  positions = ['QB', 'RB', 'WR', 'TE', 'D/ST'];
  pageSize = 10;
  filterPosition = null;
  filterOwner = null;
  searchName = '';
  wonPlayers = true;
  inProgressPlayers = true;
  noBidPlayers = true;
  constructor(
    private db: AngularFirestore,
    public timeService: TimeService,
    public ownerService: OwnerService
  ) {}

  ngOnInit() {
    this.db
      .collection('players')
      .valueChanges()
      .subscribe(players => {
        this.allPlayers = players as IPlayer[];
        this.filter();
      });
    if (window.innerWidth <= 800 && window.innerHeight <= 800) {
      this.pageSize = 5;
      this.displayedColumns = [
        'name',
        'position',
        'projectedPoints',
        'hbt',
        'hbta'
      ];
    } else {
      this.displayedColumns = [
        'firstName',
        'lastName',
        'position',
        'projectedPoints',
        'lastYearPoints',
        'byeWeek',
        'team',
        'hbt',
        'hbo',
        'hba',
        'hby',
        'hbta'
      ];
    }
  }

  filter() {
    const filteredPlayers = this.allPlayers.filter(player => {
      if (this.filterPosition && player.position !== this.filterPosition) {
        return false;
      }
      if (
        this.filterOwner &&
        (!player.highestBid || player.highestBid.owner !== this.filterOwner)
      ) {
        return false;
      }
      if (
        this.searchName &&
        !(
          player.firstName.toLowerCase() +
          ' ' +
          player.lastName.toLowerCase()
        ).includes(this.searchName.toLocaleLowerCase())
      ) {
        return false;
      }
      if (!this.noBidPlayers && !player.highestBid) {
        return false;
      }
      if (
        !this.inProgressPlayers &&
        player.highestBid &&
        this.timeService.getTimeLeftInt(
          player.highestBid.time,
          this.timeService.currentTimeInt
        ) > 0
      ) {
        return false;
      }
      if (
        !this.wonPlayers &&
        player.highestBid &&
        this.timeService.getTimeLeftInt(
          player.highestBid.time,
          this.timeService.currentTimeInt
        ) < 0
      ) {
        return false;
      }
      return true;
    });
    this.players = new MatTableDataSource(filteredPlayers);
    this.players.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'hbt':
          if (item.highestBid) {
            if (
              this.timeService.getTimeLeftInt(
                item.highestBid.time,
                new Date().getTime()
              ) > 0
            ) {
              return -1 * item.highestBid.time;
            }
            return -10000000000000;
          }
          return -10000000000001;
        case 'hbo':
          return item.highestBid ? item.highestBid.owner : '';
        case 'hba':
          return item.highestBid ? item.highestBid.amount : 0;
        case 'hby':
          return item.highestBid ? item.highestBid.years : 0;
        case 'hbta':
          return item.highestBid ? item.highestBid.totalAmount : 0;
        case 'name':
          return item.firstName + ' ' + item.lastName;
        default:
          return item[property];
      }
    };
    this.players.sort = this.sort;
    this.players.paginator = this.paginator;
  }
}
